/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Pagination} from "antd";
const PaginationComponent = ({
  current,
  defaultCurrent,
  onChange,
  total,
  ...props
}) => {
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return React.cloneElement(
        originalElement,
        {
          type: "button",
          className: `${originalElement.props.className || ""} text-[#999999]`.trim(),
        },
        "Previous"
      );
    }
    if (type === "next") {
      return React.cloneElement(
        originalElement,
        {
          type: "button",
          className: `${originalElement.props.className || ""} text-[#999999]`.trim(),
        },
        "Next"
      );
    }
    return originalElement;
  };

  return (
    <Pagination
      current={current}
      defaultCurrent={defaultCurrent}
      showSizeChanger={false}
      onChange={onChange}
      total={total}
      itemRender={itemRender}
      {...props}
    />
  );
};

export default PaginationComponent;
